import { HTMLAttributes } from "react";
import { BlockTitle } from "@blocks/Blocks";
import { FeedAttachmentType } from "@routes/Keyword/utils/types";

type BookletProps = {
  /** The data to be displayed in the mti booklet section. */
  mtiBookletData: FeedAttachmentType;
} & Pick<HTMLAttributes<HTMLDivElement>, "className">;

/**
 * Mti booklet card that is displayed in MTI BUSINESS BUDGET BOOK section
 * https://www.figma.com/design/QCEPjsj7Sdm5KqnY3ta5tq/TEMPLATES--WEB---APP-?node-id=1-12523&t=WWWD4wL9JTRjKHBD-4
 */
const Booklet = ({
  mtiBookletData: { title, name, urlPath, image },
}: BookletProps): React.ReactElement => {
  if (!image || !urlPath) return <></>;

  return (
    <div
      className="border-t border-gray-850 pt-2 lg:mb-8"
      data-testid="booklet-component"
    >
      <BlockTitle
        text={title}
        rootClassName="mb-4 mt-2 lg:mt-0 text-lg md:text-3xl"
      />

      <div className="flex gap-4">
        <img
          src={image.original.url}
          alt="booklet"
          className="w-1/4 md:w-2/5 lg:w-1/4"
          width={100}
          height={70}
        />

        <span className="w-3/4 font-lct text-base font-bold text-gray-850 md:w-3/5 md:text-lg lg:w-3/4">
          <a
            className="hover:underline"
            title={name}
            href={urlPath}
            target="_blank"
            rel="noreferrer"
          >
            {name}
          </a>
        </span>
      </div>
    </div>
  );
};
export default Booklet;
